import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, css, useTheme } from 'styled-components';
import { memoGeneric } from '@/js/libs/memo/index.ts';
import { useButtonDisabledContext } from '../../Controls/Button/disabled-context.js';
import { getColor } from './helpers.js';
export const Component = styled.svg `
  min-width: ${({ width }) => `${width}px`};
  ${({ align }) => align === 'top' &&
    css `
      transform: rotate(0);
    `}
  ${({ align }) => align === 'top-right' &&
    css `
      transform: rotate(45deg);
    `}
  ${({ align }) => align === 'right' &&
    css `
      transform: rotate(90deg);
    `}
  ${({ align }) => align === 'right-bottom' &&
    css `
      transform: rotate(135deg);
    `}
  ${({ align }) => align === 'bottom' &&
    css `
      transform: rotate(180deg);
    `}
  ${({ align }) => align === 'bottom-left' &&
    css `
      transform: rotate(225deg);
    `}
  ${({ align }) => align === 'left' &&
    css `
      transform: rotate(270deg);
    `}
  ${({ align }) => align === 'left-top' &&
    css `
      transform: rotate(315deg);
    `}
`;
export const BaseComponent = memoGeneric(function BaseComponent(props) {
    const { size = 20, color: colorProperty, className, onClick, alt, dataTestId, disabled: disabledProperty, ref, iconRender, align, viewBox = '0 0 24 24', } = props;
    const disabled = useButtonDisabledContext();
    const theme = useTheme();
    const color = React.useMemo(() => getColor({
        color: !colorProperty && disabled !== undefined ? 'currentcolor' : colorProperty,
        disabled: disabledProperty ?? disabled,
        alt,
        theme,
    }), [colorProperty, disabledProperty, alt, theme, disabled]);
    return (_jsx(Component, { align: align, className: className, onClick: onClick, ref: ref, width: size, height: size, viewBox: viewBox, fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "data-testid": dataTestId, children: iconRender(color, props) }));
});
